import { cloudProviderSchema } from '../../../schemas/cloud-provider.schema';
import { companyTypeSchema } from '../../../schemas/company-type.schema';
import { z } from 'zod/v4';

export const partnerAccountSchema = z.object({
  alias: z.string(),
  companyType: companyTypeSchema,
  createdBy: z.string(),
  expirationDate: z.string(),
  id: z.number(),
  isDeleted: z.boolean(),
  isFound: z.boolean(),
  isPrimary: z.boolean(),
  isTest: z.boolean(),
  modifiedBy: z.string(),
  name: z.string(),
  cloudProvider: cloudProviderSchema,
});

export type PartnerAccount = z.infer<typeof partnerAccountSchema>;
